import type { ReactNode } from "react"

// Small line icons for the toolbars (18 × 18, currentColor).

const Icon = ({ children }: { readonly children: ReactNode }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" aria-hidden>
    {children}
  </svg>
)

export const CursorIcon = () => (
  <Icon>
    <path d="M5 2.5v11l3-3 2 4.5 1.6-.7-2-4.4h4.2z" strokeLinejoin="round" />
  </Icon>
)
export const TrendIcon = () => (
  <Icon>
    <path d="M3 14L15 4" />
    <circle cx="3" cy="14" r="1.4" />
    <circle cx="15" cy="4" r="1.4" />
  </Icon>
)
export const FibIcon = () => (
  <Icon>
    <path d="M2 3.5h14M2 7h14M2 10.5h14M2 14h14" />
    <path d="M4 14L14 3.5" strokeDasharray="1.5 1.5" />
  </Icon>
)
export const PatternIcon = () => (
  <Icon>
    <path d="M2 13l3.5-7 3 5 3.5-8 4 10" strokeLinejoin="round" />
  </Icon>
)
export const ForecastIcon = () => (
  <Icon>
    <rect x="3" y="3" width="12" height="5" />
    <rect x="3" y="10" width="12" height="5" />
  </Icon>
)
export const ShapeIcon = () => (
  <Icon>
    <path d="M3 14c2-5 4-1 6-5s3-4 6-6" />
    <rect x="9.5" y="10" width="5.5" height="5" />
  </Icon>
)
export const TextIcon = () => (
  <Icon>
    <path d="M4 4h10M9 4v11M7 15h4" />
  </Icon>
)
export const MagnetIcon = () => (
  <Icon>
    <path d="M4 3v6a5 5 0 0010 0V3h-3v6a2 2 0 01-4 0V3z" strokeLinejoin="round" />
  </Icon>
)
export const PinIcon = () => (
  <Icon>
    <path d="M7 2.5h4l-.5 4 2.5 2.5H5l2.5-2.5zM9 9v6.5" strokeLinejoin="round" />
  </Icon>
)
export const EyeIcon = () => (
  <Icon>
    <path d="M1.5 9S4.5 4 9 4s7.5 5 7.5 5-3 5-7.5 5S1.5 9 1.5 9z" />
    <circle cx="9" cy="9" r="2" />
  </Icon>
)
export const EyeOffIcon = () => (
  <Icon>
    <path d="M1.5 9S4.5 4 9 4s7.5 5 7.5 5-3 5-7.5 5S1.5 9 1.5 9zM3 15L15 3" />
  </Icon>
)
export const TrashIcon = () => (
  <Icon>
    <path d="M3 5h12M7 5V3h4v2M5 5l1 10h6l1-10M8 8v4M10 8v4" strokeLinejoin="round" />
  </Icon>
)
export const GearIcon = () => (
  <Icon>
    <circle cx="9" cy="9" r="2.3" />
    <path d="M9 2v2M9 14v2M2 9h2M14 9h2M4 4l1.4 1.4M12.6 12.6L14 14M4 14l1.4-1.4M12.6 5.4L14 4" />
  </Icon>
)
export const CloseIcon = () => (
  <Icon>
    <path d="M4 4l10 10M14 4L4 14" />
  </Icon>
)
export const IndicatorsIcon = () => (
  <Icon>
    <path d="M7 15c1-6 1-10 4-11M5 8h6" />
    <path d="M11.5 10.5l4 4M15.5 10.5l-4 4" />
  </Icon>
)

export const LockIcon = () => (
  <Icon>
    <rect x="4" y="8" width="10" height="7" rx="1" />
    <path d="M6 8V6a3 3 0 016 0v2" />
  </Icon>
)
export const UnlockIcon = () => (
  <Icon>
    <rect x="4" y="8" width="10" height="7" rx="1" />
    <path d="M6 8V6a3 3 0 015.8-1" />
  </Icon>
)
export const CloneIcon = () => (
  <Icon>
    <rect x="6" y="6" width="9" height="9" rx="1" />
    <path d="M3 12V4a1 1 0 011-1h8" />
  </Icon>
)
export const FrontIcon = () => (
  <Icon>
    <rect x="3" y="3" width="8" height="8" />
    <rect x="7" y="7" width="8" height="8" fill="currentColor" fillOpacity="0.35" />
  </Icon>
)
export const BackIcon = () => (
  <Icon>
    <rect x="7" y="7" width="8" height="8" />
    <rect x="3" y="3" width="8" height="8" fill="currentColor" fillOpacity="0.35" />
  </Icon>
)

export const ChevronUpIcon = () => (
  <Icon>
    <path d="M5 11l4-4 4 4" />
  </Icon>
)

export const ChevronDownIcon = () => (
  <Icon>
    <path d="M5 7l4 4 4-4" />
  </Icon>
)

export const WatchlistIcon = () => (
  <Icon>
    <path d="M3 4.5h12M3 9h12M3 13.5h7M12.5 12l1.5 1.5 2.5-3" />
  </Icon>
)
